module.exports = __webpack_public_path__ + "img/dsv.6ec35843.png";